module.exports = __webpack_public_path__ + "static/illustration-requirements-granulocyte@2x-e2f991c89b736436a7ed412ac48ca7bd.png";